class CartCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.cart-carousel__track');
    this.dots = this.querySelectorAll('.cart-carousel__dot');
    this.slideCount = parseInt(this.dataset.slideCount) || 1;
    this.currentIndex = 0;

    this.touchStartX = 0;
    this.touchEndX = 0;

    this.init();
  }

  init() {
    if (this.slideCount <= 1) return;

    // Touch swipe
    this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
    this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });
    this.addEventListener('touchend', this.handleTouchEnd.bind(this));

    // Dot clicks
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Click to cycle
    this.track.addEventListener('click', () => this.cycleNext());
  }

  cycleNext() {
    const nextIndex = (this.currentIndex + 1) % this.slideCount;
    this.goToSlide(nextIndex);
  }

  handleTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
  }

  handleTouchMove(e) {
    this.touchEndX = e.touches[0].clientX;
  }

  handleTouchEnd() {
    const diff = this.touchStartX - this.touchEndX;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // Swipe left - next
        this.goToSlide((this.currentIndex + 1) % this.slideCount);
      } else {
        // Swipe right - prev
        this.goToSlide((this.currentIndex - 1 + this.slideCount) % this.slideCount);
      }
    }

    this.touchStartX = 0;
    this.touchEndX = 0;
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.track.style.transform = `translateX(-${index * 100}%)`;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }
}

customElements.define('cart-carousel', CartCarousel);
